//global

var sample_free_id_collection = 19761508253758;
var sample_4x4_id_collection = 38532452044;
var sample_paid_id_collection = 31658742317118;
var sample_select_id_collection = 39972832313527;
var sample_premium_id_collection = 39972833984695;
var current_variant_id = "";
var product_data = [];
var product_handle = "";
var cache_cart;
var el;
var sampleType= "";

var brand = "";

$(document).on('click', '.collection-sample-button', function(){
  var handle = $(this).data('handle');
  product_data = GetProductData(handle);
  product_handle = handle;
  AddVariantDropDown(product_data);
  brand = $(this).data('brand');
  
  
});

$(document).on('change', '.collection-modal-option-wrapper select', function(){
  console.log($(this).val());
  current_variant_id = $(this).val();
  /*
  if(product_data["variants"][current_variant_id]["sample_data"] === undefined || product_data["variants"][current_variant_id]["sample_data"] === null ){
    product_data["variants"][current_variant_id]["sample_data"] = GetSampleData(product_data["variants"][current_variant_id]);
    console.log(product_data);
  }
  */

  //get the full sample data
  if(product_data["variants"][current_variant_id]["sample_data"] === undefined || product_data["variants"][current_variant_id]["sample_data"] === null ){
    product_data["variants"][current_variant_id]["sample_data"] = getFullSampleData(product_data["variants"][current_variant_id]);
    console.log(product_data);
  }
  
  InitModal(product_data["variants"]);
  
});

function AddVariantDropDown(product_data){
  var options = product_data.options;
  var variants = product_data.variants;
  $( '#collection-modal-product-option-1').empty();
  for (var key in options) {
    if (options.hasOwnProperty(key)) {
      const values = Object.values(options[key]);
      for( var i = 0; i < values.length; i++){
        var variant_id = "";
        //search for variant id -- works on single variants only
        for (var id in variants) {
          if (variants.hasOwnProperty(id)) {
            if(variants[id]['title'] == values[i]){
              variant_id = id;
            }
          }
        }
        
        
        $('#collection-modal-product-option-1').append("<option value=" + decodeURI(variant_id) + " data-position="+ i +">"+ decodeURI(values[i])  +"</option>");
      	$('#collection-modal-product-option-label-1').text(key)
      }
      // Do things here
    }
  }
  
  //make the first option selected
  $("#collection-modal-product-option-1")[0].selectedIndex = 0;
  $("#collection-modal-product-option-1").trigger('change');
  
}


function GetProductData(handle){
  var url = "/products/"+handle+"?view=collection_modal";
  var product_data = [];
  $.ajax({
      dataType: "html",
      async: false,
      url: url,
      success: function(product){
		product_data = JSON.parse( product ); 
        product_data['title'] = decodeURI(product_data['title']);
      }
  });
  
  console.log(product_data);
  
  return product_data;
}



function updateSampleIDs(variant_meta){
    
  let sampleMetaField = variant_meta[current_variant_id]['sample'];
  if (sampleMetaField == 'free'){
    sample_free_id_collection = 19761508253758; // product id for generic free sample product
  } else if (sampleMetaField == '4x4') {
    sample_4x4_collection= 38532452044; // product id for generic 4x4 sample product
  } else if (sampleMetaField == 'full' || sampleMetaField == "full_only") {
    sample_full_collection = variant_meta[current_variant_id]['sample_id']; // product id for full sample product
    sample_4x4_collection= 38532452044;
  } else if (sampleMetaField == 'sample'){
    sample_paid_id_collection = 31658742317118; // product id for generic paid sample product
  }

}

//not being used. Replaced by GetFullSampleData
function GetSampleData(variant_data){    
    var sample_id = decodeURI(variant_data['sample_id']);
    var url = "/products/"+sample_id+"/json";
    var sample_data = [];
    var parent_unit = variant_data['unit'];

    console.log(url);

    $.ajax({
      dataType: "json",
      async: false,
      url: url,
      success: function(sample){

        sample_data['id'] = sample.product.variants[0].id;
        sample_data['title'] = sample.product.title;
        sample_data['price'] = sample.product.price;
        sample_data['img_url'] = sample.product.image.src;

        console.log('sample', sample)

        for( var i = 0; i < sample.product.tags.length; i++){
          if(sample.product.tags[i].includes("unit")){
            var unit = sample.product.tags[i].split("_");
            sample_data['unit'] = unit[1];
          }else if(sample.product.tags[i].includes("factor")){
            var factor = sample.product.tags[i].split(":");
            sample_data['factor'] = factor[2];
          }else if(sample.product.tags[i].includes("type")){
            var type = sample.product.tags[i].split("_");
            sample_data['type'] = type[1].toLowerCase();
          }else if(sample.product.tags[i].includes("measure")){
            var measure = sample.product.tags[i].split("_");
            sample_data['measure'] = measure[1];
          }  

        }

        sample_data['unit'] = parent_unit;

      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log('xhr.status ' + xhr.status);
        console.log('ajax error: ' + thrownError);
      }
    });
    return sample_data;  
}

function InitModal(variant_meta){


  
  $('.collection-modal-product-title').text(decodeURI(product_data['title']));

  // prepare modal
  $("input[name=select-sample]:radio").prop( "checked", false );

  if (!$("input[name=select-sample]:radio").is(':checked')){

    $('#sampleATC').text('Select a sample');
  }
  
  let sample_type = variant_meta[current_variant_id]['sample'];

  changeSampleDescription(variant_meta[current_variant_id]['sample_data'], $('#sample-quantity-show').val(), variant_meta[current_variant_id]);

  if (sample_type  != 'full' && sample_type  != 'full_only' && sample_type != "FullPremium" ) { // free or 4x4 or sample

    $('.radio.two').hide();
    $('.qty').hide();
    $('.sample-modal.order-desc').hide();
    $('#sampleATC').prop('disabled', true);
    
    console.log('going to not full sample');

    if (cartHasSample('free') || cartHasSample('4x4')) {
      $('#sampleATC').text('Sample added');
    }

    if (sample_type == 'free') {

      console.log("free sample");

      $('.sample-radio-label.1').contents().filter(function (){
        return this.nodeType === 3 && this.textContent.trim().length;
      }).replaceWith('  Free Sample');

      $('.sample-select-label.1').html('We send you the largest size sample we have available. Free Shipping. Subject to Availability');
    } else if (sample_type == 'sample' 
               || sample_type == '4x4SelectSample'
               || sample_type == '4x4PremiumSample') {
          
          console.log("paid sample");
          
          $('.sample-radio-label.1').contents().filter(function (){
        	return this.nodeType === 3 && this.textContent.trim().length;
          }).replaceWith('Sample');
      
      if(sample_type == "sample"){
        $('div.sample-select-label.1').html('We send you the largest size sample we have available. Free Shipping.');
      }else if(sample_type == "4x4SelectSample"){ 
        $('label.sample-radio-label.1').html('4x4 Select Sample');
        $('div.sample-select-label.1').html('4”x4” square sample tile.<br>Free shipping.');
      }else if(sample_type == "4x4PremiumSample"){ 
        $('label.sample-radio-label.1').html('4x4 Premium Sample');
        $('div.sample-select-label.1').html('4”x4” square sample tile.<br>Free shipping.');
      }else{
        $('label.sample-radio-label.1').html('4x4 Sample');
        $('div.sample-select-label.1').html('4”x4” square sample tile.<br>Free shipping.');
      }


      // dont show qty and desc on sample
      if(sample_type != "sample"){
           $('#sample-order-desc').show();
      }
 
     }else { // 4x4
       

      console.log("4x4 sample");

      $('.sample-radio-label.1').contents().filter(function (){
        return this.nodeType === 3 && this.textContent.trim().length;
      }).replaceWith('  4"x4" Sample');
       
      $('.sample-modal.order-desc').hide();
      $('.sample-select-label.1').html('One 4"x4" square sample tile.<br>Only pay for shipping.');
    }

  } else { // show modal with full and 4x4 options

    console.log("full sample");

    $('.sample-radio-label.1').contents().filter(function (){
        return this.nodeType === 3 && this.textContent.trim().length;
    }).replaceWith('  Full Sized Sample');

    $('.sample-select-label.1').html('Order up to 5 full sized samples.<br>Standard shipping rates apply.');
    
    if(sample_type == "FullPremium"){
      $('label.sample-radio-label.2').html('4"x4" Premium Sample');
      $('div.sample-select-label.2').html('4”x4” square sample tile.<br>Free shipping.');
    }else{
      $('label.sample-radio-label.2').html('4"x4" Sample');
      $('div.sample-select-label.2').html('One 4"x4" square sample tile.<br>Only pay for shipping.');
    }
    
    if(variant_meta[current_variant_id]['sample'] != "full_only"){
    	$('.radio.two').show();
    }else{
      $('.radio.two').hide();
    }
    $('.qty').show();
    $('#sample-order-desc').show();
    //$('#sample-quantity-show').prop('disabled', true);
    $('#sample-order-desc').css('color', '#4d4d4d');


    $('#sample-order-desc').show();

  }

};  

function changeSampleDescription(sample_data, quantity, variant_data){
  
  
  
    if(sampleType == "full" || sampleType == "full_only" || sampleType == "FullPremium"){
    	$('#sample-order-desc').html(FullSampleDescription(sample_data, quantity, variant_data));
    }else if(sampleType == "sample"){
      var sample_price = 9.99;
      var total = sample_price * quantity;
      $('#sample-order-desc').html(quantity + " piece(s) x $9.99/pc = $" + total.toFixed(2)); 
    }else if(sampleType == "4x4SelectSample"){
      var sample_price = 10;
      var total = sample_price * quantity;
      $('#sample-order-desc').html(quantity + " piece(s) x $10/pc = $" + total.toFixed(2)); 
    }else if(sampleType == "4x4PremiumSample"){
      var sample_price = 15;
      var total = sample_price * quantity;
      $('#sample-order-desc').html(quantity + " piece(s) x $15/pc = $" + total.toFixed(2)); 
    }
  
    //console.log(template);
    
  }


function FullSampleDescription(sample_data, quantity, variant_data){
  var type;
  var factor;
  var unit;
  var price;

  if(typeof sample_data == 'undefined' || sample_data['type'] == "" || sample_data['type'] == null){
    type = variant_data['type'];
  }else{
    type = sample_data['type'];
  }

  if(typeof sample_data  == 'undefined' || sample_data['factor'] == "" || sample_data['factor'] == null){
    factor = variant_data['factor'];
  }else{
    factor = sample_data['factor'];
  }

  if(typeof sample_data  == 'undefined' || sample_data['unit'] == "" || sample_data['unit'] == null){
    unit = variant_data['unit'];
  }else{
    unit = sample_data['unit'];
  }

  price = variant_data['price'] / 100;  

  var type_unit = type + "_" + unit;
  type_unit = type_unit.toLowerCase();

  var category = "";

  switch (type_unit){
      case "tile_sqft":
      case "cobble_sqft":
      case "pavers_sqft":
      case "coping_sqft":
      case "ledger_sqft":
      case "ledger cap_sqft":
      case "wall cap_sqft":
      case "threshold_sqft":
        if(quantity == 1){
          var type_desc = "tile";
        }else{
          var type_desc = "tiles";
        }
        category = "tile_sqft";
          break;
      case "mosaic_sqft":
        if(quantity == 1){
            var type_desc = "sheet";
        }else{
          var type_desc = "sheets";
        }
        category = "mosaic_sqft";
          break;
      case "mosaic_pc":
    case "pebble_sheet":
    case "mosaic_sheet":
        if(quantity == 1){
            var type_desc = "sheet";
        }else{
          var type_desc = "sheets";
        }
        category = "mosaic_pc";
          break;
      case "pebble_pc":
        if(quantity == 1){
            var type_desc = "piece";
        }else{
          var type_desc = "pieces";
        }
        category = "mosaic_pc";
          break;
      case "liner_pc":
      case "table_pc":
      case "ledger_pc":
      case "molding_pc":
      case "wainscot_pc":
      case "baseboard_pc":
      case "coping_pc":
      case "column cap_pc":
      case "wall cap_pc":
      case "threshold_pc":
      case "border_pc":
          if(quantity == 1){
            var type_desc = "piece";
          }else{
            var type_desc = "pieces";
          }
          category = "liner_pc";
          break;
      default:
          if(quantity == 1){
            var type_desc = "tile";
          }else{
            var type_desc = "tiles";
          }
          category ="tile_sqft";
          break;
  }


  var total_price = price * factor * quantity;
  total_price = total_price.toFixed(2);
  var lc_unit = unit.toLowerCase();
  var template = "";

  factor = parseFloat(factor);
  if(!isNaN(factor)){
    factor = factor.toFixed(2);
  }

  if(category == "tile_sqft" || category == "mosaic_sqft"){

    if(quantity == 1){
    template = "{quantity} {typedesc} is {factor} {unit}.<br>{factor} {unit} x ${price}/{unit} = ${total_price}";
    }else{
      var total_factor = quantity * factor;
      total_factor = total_factor.toFixed(2)
      //console.log(total_factor + " total-factor");
      template = "{quantity} {typedesc} are {totalfactor} {unit}.<br>{totalfactor} {unit} x ${price}/{unit} = ${total_price}";
      template = template.replace(/\{totalfactor\}/g, total_factor);
    }

    // $("#sample-price").html(total_price);      
  }else if ( category == "mosaic_pc" || category == "liner_pc"){
    template = "{quantity} {typedesc} x ${price}/{unit} = ${totalpc}";
    var total_pc = quantity * price;
    total_pc = total_pc.toFixed(2);
    template = template.replace(/\{totalpc\}/g, total_pc);
    // $("#sample-price").html(total_pc);
  }

  template = template.replace(/\{typedesc\}/g, type_desc);
  template = template.replace(/\{quantity\}/g, quantity);
  template = template.replace(/\{factor\}/g, factor);
  template = template.replace(/\{unit\}/g, unit);
  template = template.replace(/\{price\}/g, price);
  template = template.replace(/\{total_price\}/g, total_price);

  $('#sample-order-desc').html(template);
  //console.log(template);

}

function getFullSampleData(variant_data){
      
  if( variant_data['sample_id'] && variant_data['sample_id'] != "" && variant_data['sample_data'] == null) {       
    var url = "/products/"+variant_data['sample_id']+"/json";
    var sample_data = [];
    var parent_unit = variant_data['unit'];

    $.ajax({
      dataType: "json",
      async: false,
      url: url,
      success: function(sample){

        sample_data['id'] = sample.product.variants[0].id;
        sample_data['title'] = sample.product.title;
        sample_data['price'] = sample.product.price;
        sample_data['img_url'] = sample.product.image.src;

        let tags = sample.product.tags.split(",");

        for( var i = 0; i < tags.length; i++){
          if(tags[i].includes("unit")){
            var unit = tags[i].split("_");
            sample_data['unit'] = unit[1];
          }else if(tags[i].includes("factor")){
            var factor = tags[i].split(":");
            sample_data['factor'] = factor[2];
          }else if(tags[i].includes("type")){
            var type = tags[i].split("_");
            sample_data['type'] = type[1].toLowerCase();
          }else if(tags[i].includes("measure")){
            var measure = tags[i].split("_");
            sample_data['measure'] = measure[1];
          }  

        }

        sample_data['unit'] = parent_unit;

      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log('xhr.status ' + xhr.status);
        console.log('ajax error: ' + thrownError);
      }
    });
    return sample_data;
  }else{        
    return variant_data['sample_data'];
  }      
}

function cartHasSample(sampleType) {
  let res = false;
  cache_cart.items.forEach(function(i){
    if (i.properties) {
      if (i.properties['_product-handle'] == product_handle && i.properties._sample == sampleType ) {           
        res = true;
      }
    } 
  });   
  return res;     
}

$('#sampleATC').click(function(e) {
  e.preventDefault();
  
  

  // close sample tasks
  $("body").removeClass("modal-open");
  $('.site-header-announcement').css('z-index', 700);   
  $('#shopify-section-static-footer').show();
  
  var variant_meta = product_data['variants'];
  var product_title = decodeURI(product_data['title']);

  let data, sampleId;
  let cartRequestType = "add";

  if(sampleType == "full" || sampleType == "full_only" || sampleType == "FullPremium") {

    let fullSampleData = getFullSampleData(variant_meta[current_variant_id]);
    console.log(fullSampleData);
    let fullSampleTitle = fullSampleData.title.substr(fullSampleData.title.indexOf(' - ') + 2);
    data = {
      quantity: $('#sample-quantity-show').val(),
      id: fullSampleData.id,
      properties: {
        '_sample': "full",
        '_product': fullSampleTitle,
        '_product-handle': product_handle,
        '_variant_id': variant_meta[current_variant_id]['id'],
        '_unit': variant_meta[current_variant_id]['unit'],
        '_brand': brand,
        //'img': variant_meta[current_variant_id]['img_url'],
      }
    };    

    if (cartHasSample("full")){
      cartRequestType = "change";
    }

  } else {

    // 4x4 or free
    var quantity = 1;
    if(sampleType == '4x4'){
      sampleId = sample_4x4_id_collection;
      
    }else if(sampleType == "sample"){
      sampleId = sample_paid_id_collection;
      
    }else if(sampleType == "4x4SelectSample"){
      sampleId = sample_select_id_collection;
      quantity = $('#sample-quantity-show').val();
      
    }else if(sampleType == "4x4PremiumSample"){
      sampleId = sample_premium_id_collection;
      quantity = $('#sample-quantity-show').val();
      
    }else if(sampleType == "free"){
      sampleId = sample_free_id_collection;
    }
    
    
    if (cartHasSample("sample") ){
      cartRequestType = "change";
    }

    data = {
      quantity: quantity,
      id: sampleId, 
      properties: {
        '_sample': sampleType,
        //'master-product-id': current_variant_id,
        '_product-handle': product_handle,
        '_variant_id': variant_meta[current_variant_id]['id'],
        'Product': product_title + " - "  + decodeURI(variant_meta[current_variant_id]['title']),
        '_product': product_title + " - "  + decodeURI(variant_meta[current_variant_id]['title']),
        '_brand': brand,
        '_unit': variant_meta[current_variant_id]['unit'],
        '_sku': variant_meta[current_variant_id]['sku']
      }
    };  
    
  }

  if (data) {
    console.log(sampleType + ' Sample Data: ');
    console.log(data);
    AddSampleToCart(data, cartRequestType);
    $('.site-header-announcement').css('z-index', 700);

    //$('.site-header-button-cart').effect( "bounce", "100" );

  }

});

function InitCart(){
  $.ajax({
    type: 'GET',
    async: false,
    url: '/cart.js',
    dataType: 'json',
    success: function(cartdata){
      cache_cart = cartdata;
    }
  }); 
}

function UpdateCart(){
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cartdata){
      cache_cart = cartdata;
    }
  }).done(function (response) {  

    // update cart icon

    if (cache_cart.item_count > 0 ) {
      $('#cartCount').css('opacity', '1');
      $('.site-header-cart--count').attr('data-header-cart-count', response.item_count);

                }
    // return location.href = '/cart';

  });    
}

function AddSampleToCart(data, type){
  if( type == "add"){
    url = '/cart/add.js';
  }else{
    url = '/cart/change.js';
  }

  //console.log(data);

  $.ajax({
    method: "POST",
    dataType: "json",
    async: true,
    url: url,
    data: data,
    success: function(cart){

      UpdateCart();
      $('.collection-sample-button[data-handle="' + product_handle + '"]').closest('.productitem--info').find('.collection-sample-success').addClass('show');
      $('.collection-sample-button[data-handle="' + product_handle + '"]').hide();
      


      $('#sampleButton').text('Sample Added');
      $("#sampleButton").attr("disabled", false); 
      
      $('.fancybox-close-small').trigger('click');

    },

  });

}

$(document).ready(function(){
  
  $(document).on('click', '.modal-close', function(){
    $('.fancybox-close-small').trigger('click');
  });
  
  
  
  // full tile sample description update when sample quantity select changes
    $('#sample-quantity-show').change(function(o) {
      var variant_meta = product_data['variants'][current_variant_id];
      changeSampleDescription(variant_meta['sample_data'], $('#sample-quantity-show').val(), variant_meta);
    });
    
    // sample modal select sample type change
    $("input[name=select-sample]:radio").change(function () {
      
      console.log('custom-modal');
      var variant_meta = product_data['variants'][current_variant_id];
      let sampleMetafield = variant_meta['sample'];
      let checkedVal = $("input[name=select-sample]:checked").val();
      
      if (checkedVal == "1") { // free, 4x4, or full
        sampleType = sampleMetafield;
      } else { // radio2 only appears if metafield = full, it will always be 4x4

        // full premium has 4x4PremiumSample
        if(sampleMetafield == "FullPremium"){
          sampleType = "4x4PremiumSample"
        }else{
        	sampleType = "4x4";
        }
        
      }
      
      if (sampleType == "full" || sampleType == "full_only" || sampleType == "FullPremium" ){
               
        //$('#sample-quantity-show').prop('disabled', false);
        $('#sample-order-desc').css('color', '#006dd4');
              
        // update order description 
        changeSampleDescription(variant_meta['sample_data'], $('#sample-quantity-show').val(), variant_meta);
        $('#sampleATC').text("Add to cart");
        $("#sampleATC").attr("disabled", false);   

        //show qty
        $('.sample-modal.qty').show();
        
      }else if (sampleType == "4x4SelectSample" || sampleType == "4x4PremiumSample"){
  
        $('#sample-order-desc').css('color', '#006dd4');
              
        // update order description 
        changeSampleDescription(variant_meta['sample_data'], $('#sample-quantity-show').val(), variant_meta);

        if(cartHasSample("4x4SelectSample") || cartHasSample("4x4PremiumSample")){
          $('#sampleATC').text("Sample added");
          $("#sampleATC").attr("disabled", true);
        }else{
          $('#sampleATC').text("Add to cart");
          $("#sampleATC").attr("disabled", false); 
        }

        //hide qty
        $('.sample-modal.qty').hide();
        
        
        
      }  else { // 4x4 or free
        
        //$('#sample-quantity-show').prop('disabled', true);
        $('#sample-order-desc').css('color', '#4d4d4d');
        
        // update sample button
        if (cartHasSample("free") || cartHasSample("4x4")){    
          $('#sampleATC').text("Sample added");
          $("#sampleATC").attr("disabled", true);
        } else {
          $('#sampleATC').text("Add to cart");
          $("#sampleATC").attr("disabled", false);  
        }      

        //hide qty
        $('.sample-modal.qty').hide();
      }
    });
  
  
  //buildcache cart on load
  InitCart();
  
  el = $('#cartCount');
  
  
});